import { useEffect, useState } from "react";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import type { SxProps } from "@mui/material/styles";
import useTheme from "@mui/material/styles/useTheme";

export interface MicrophoneDevice {
  deviceId: string;
  label: string;
}

type SpeakerFormFieldProps = {
  label: string;
  value: string;
  color?: string;
  onChange: (deviceId: string) => void;
  sx?: SxProps;
};
export default function SpeakerFormField({
  label,
  value,
  color,
  sx,
  onChange
}: SpeakerFormFieldProps) {
  const theme = useTheme();
  const [speakers, setSpeakers] = useState<MicrophoneDevice[]>([]);

  useEffect(() => {
    const fetchSpeakers = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const speakerDevices = devices
          .filter((device) => device.kind === "audiooutput")
          .map((device) => ({
            deviceId: device.deviceId,
            label: device.label || `Speaker ${devices.indexOf(device) + 1}`
          }));

        setSpeakers(speakerDevices);
      } catch (error) {
        console.error("Error enumerating devices:", error);
      }
    };

    fetchSpeakers();
  }, []);

  return (
    <FormControl fullWidth sx={sx}>
      <InputLabel
        id="speaker-select-label"
        sx={{
          color,
          "&.Mui-focused": {
            color
          }
        }}
      >
        {label}
      </InputLabel>
      <Select
        labelId="speaker-select-label"
        value={value}
        onChange={(event) => onChange(event.target.value as string)}
        label={label}
        MenuProps={{
          style: { zIndex: theme.zIndex.snackbar + 2 }
        }}
      >
        {speakers.map((microphone) => (
          <MenuItem key={microphone.deviceId} value={microphone.deviceId}>
            {microphone.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
